module.exports = __webpack_public_path__ + "img/eden.4764656e.png";